import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { PasswordRuleStatusIcon } from './passwordChecklistIcons'
import {
  SP_PASSWORD_RULE_LABELS,
  SP_PASSWORD_RULE_ORDER,
  evaluateSpPasswordRules,
} from '../lib/password-rules'
import {
  resetPasswordChecklistBoxSx,
  resetPasswordChecklistItemSx,
  resetPasswordChecklistItemTextSx,
  resetPasswordChecklistTitleSx,
} from '../styles/resetPasswordStyles'

interface PasswordChecklistProps {
  readonly password: string
}

export function PasswordChecklist({ password }: PasswordChecklistProps) {
  const checks = evaluateSpPasswordRules(password)
  const showIcons = password.length > 0

  return (
    <Box
      data-testid="password-requirements-checklist"
      sx={resetPasswordChecklistBoxSx}
    >
      <Typography component="p" sx={resetPasswordChecklistTitleSx}>
        Password must contain:
      </Typography>
      <Box
        component="ul"
        sx={{ listStyle: 'none', m: 0, p: 0, display: 'flex', flexDirection: 'column', gap: '4px' }}
      >
        {SP_PASSWORD_RULE_ORDER.map((key) => {
          const met = checks[key]
          return (
            <Box
              component="li"
              key={key}
              data-testid={`password-rule-${key}`}
              data-met={met ? 'true' : 'false'}
              sx={resetPasswordChecklistItemSx}
            >
              <Typography component="span" sx={resetPasswordChecklistItemTextSx}>
                {showIcons ? '' : '• '}
                {SP_PASSWORD_RULE_LABELS[key]}
              </Typography>
              <PasswordRuleStatusIcon met={met} show={showIcons} />
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}
